import VSLogo from "../../images/VirtuallySportsWebLogo.webp";
import { Loader } from "./Loader";

interface LoadingScreenProps {
  showLoadingScreen: boolean;
}

export function LoadingScreen({ showLoadingScreen }: LoadingScreenProps) {
  if (!showLoadingScreen) return null;
  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center w-full h-full bg-background">
      <img
        src={VSLogo}
        alt="Virtually Sports logo"
        className="w-2/3 animate-pulse"
      />
      <Loader />
    </div>
  );
}
